module.exports = "../../../../platform/assets/pageMainIcon/business_danjuweihulei4.svg";